import styled from 'styled-components';

export const StyledDiscountIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-left: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  margin-left: 18px;
  margin-right: -14px;
`;

export const StyledDiscountContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 3;

  div {
    :not(:last-of-type) {
      margin-bottom: 4px;
    }
  }
`;
